import VueBottomSheet from '@webzlodimir/vue-bottom-sheet'
import Vue from 'vue'

Vue.use(VueBottomSheet)
